import React from 'react';
import PropTypes from 'prop-types';

import {
  IonContent,
  IonPage,
  IonAlert
} from '@ionic/react';
import { connect } from 'react-redux'

interface Props {
}

interface ClassState {
  data: any;
}

class ErrorAlert extends React.Component<Props, ClassState> {
  constructor(props: any) {
    super(props)
    this.state = {data: props.data}
  }

  componentWillReceiveProps(nextProps: any){
    this.setState({
      data: nextProps.data,
    });
  }

  render() {
    const { error, error401, errorServer } = this.state.data;
    return (
      <>
        <IonAlert
          backdropDismiss={false}
          isOpen={error}
          header={'Error en la solicitud'}
          subHeader={'Verifique si conexión a internet.'}
          message={'Si el problema persiste contacte al administrador de la aplicación.'}
          buttons={[
            {
              text: 'Recargar',
              handler: () => {
                window.location.reload();
              }
            },
            {
              text: 'Cerrar sesión',
              handler: () => {
                localStorage.removeItem("token_codesii");
                window.location.href = "/login";
              }
            }
          ]}
        />
        <IonAlert
          backdropDismiss={false}
          isOpen={error401}
          header={'Error en la solicitud'}
          subHeader={'Su sessión a expirado.'}
          message={''}
          buttons={[
            {
              text: 'Iniciar sessión',
              handler: () => {
                localStorage.removeItem("token_codesii");
                window.location.href = "/login";
              }
            }
          ]}
        />
        <IonAlert
          backdropDismiss={false}
          isOpen={errorServer}
          header={'Error en la solicitud'}
          subHeader={'Verifique si conexión a internet.'}
          message={'Si el problema persiste contacte al administrador de la aplicación.'}
          buttons={[
            {
              text: 'Recargar',
              handler: () => {
                window.location.reload();
              }
            }
          ]}
        />
      </>
    );
  };
}

const mapStateToProps = (state: any) => {
  return {
    data: state.data
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(ErrorAlert);
